import { useMemo } from 'react';

import { useLocation } from '@reach/router';
import queryString from 'query-string';

export const useContentManagerParams = (
  pageValues: string,
): Record<string, string> => {
  const { search } = useLocation();
  const params = useMemo(() => {
    // get the params from the url
    const searchParams = queryString.parse(search);

    // cleanup the search object since params could be null
    return Object.keys(searchParams)
      .filter(k => searchParams[k] !== null)
      .reduce((a, k) => ({ ...a, [k]: searchParams[k] }), {});
  }, [search, pageValues]);

  return params;
};
